import React from "react";
import Header from "../../components/layout/header";
import Footer from "../../components/layout/footer";
import TermsAndConditions from "../dashboard/TermsAndConditions";
import "./index.scss";

const TermsAndConditionsPage = () => {
  return (
    <>
        <Header/>
            <section className="terms-and-conditions-section">
                <TermsAndConditions/>
            </section>
        <div className="footer-block">
            <Footer/>
        </div>
    </>
  );
};

export default TermsAndConditionsPage;